import React from 'react'
import PropTypes from 'prop-types'
import TimelineItem from './TimelineItem'

function Events({ events, providerCity }) {
  return (
    <div className="timeline">
      {
        events.map((event, index) => (
          <TimelineItem
            key={event?.id}
            index={index}
            event={event}
            providerCity={providerCity}
          />
        ))
      }
    </div>
  )
}

Events.propTypes = {
  events: PropTypes.arrayOf(Object),
  providerCity: PropTypes.objectOf(Object),
}

Events.defaultProps = {
  events: [],
  providerCity: null,
}

export default Events
